import { httpClient } from '../http/httpClient'

export interface IncreaseEntryCountParams {
  name: string
}

export async function increaseEntryCount(params: IncreaseEntryCountParams) {
  const { data } = await httpClient.patch('/self-hire', null, {
    params,
  })

  return data
}
